import { cnTwMerge } from "../../utils/cnTwMerge";
import { Card } from "../shadcn/card";
import { Skeleton } from "../shadcn/skeleton";

export type MetricCardLoadingProps = {
  "data-testid"?: string;
};

export function MetricCardLoading({
  "data-testid": dataTestId,
}: MetricCardLoadingProps) {
  return (
    <Card
      className={cnTwMerge("flex flex-col p-6", "h-full")}
      data-testid={dataTestId}
      isLoading={false}
    >
      <div
        className={cnTwMerge(
          "flex flex-col gap-2 justify-between items-start flex-shrink-0 w-80 max-h-32",
        )}
      >
        <Skeleton className="h-4 w-28 pt-2" />
        <Skeleton className="h-4 w-16  pt-2" />
        <div className="flex gap-1 items-center pt-4">
          <Skeleton className="h-4 w-36" />
        </div>
      </div>
    </Card>
  );
}
